module.exports = __webpack_public_path__ + "static/img/fuwu_banner@2x.8180daa6.jpg";